import { useState } from "react";

import { format } from "date-fns";

import EyeIcon from "@/assets/icons/eye-outline.svg";
import ListMention from "@/containers/ListMention";
import AccessControl from "@components/AccessControl";
import TextButton from "@components/TextButton";
import Typography from "@components/Typography";

import styles from "../HiddenMention.module.css";
import { Mention } from "@/types/Mention";

type MentionRowProps = {
  className: string;
  mention: Mention;
  onMarkRelevant: (public_id: Mention["public_id"]) => Promise<unknown>;
};

const MentionRow = ({
  className,
  mention,
  onMarkRelevant,
}: MentionRowProps) => {
  const [deleting, setDeleting] = useState(false);

  const handleMarkRelevant = () => {
    // prevent double-clicks
    setDeleting(true);
    onMarkRelevant(mention.public_id).catch(() => {
      // Re-enable the button in the case where deletion has failed
      setDeleting(false);
    });
  };

  return (
    <ListMention
      className={className}
      {...mention}
      published_date={mention.episode_published_date}
      title={mention.episode_title}
      episode_public_url={undefined}
    >
      <AccessControl>
        <TextButton
          onClick={handleMarkRelevant}
          disabled={deleting}
          id={`mark-relevant-${mention.mention_pk}`}
          icon={EyeIcon}
        >
          {L.ACCOUNT_MENTIONS_TABLE_SHOW}
        </TextButton>
        {mention.marked_irrelevant_at && (
          <Typography variant="body-2" margin="none" className={styles.info}>
            {L.MENTIONS_VIEW_HIDDEN_LIST_HEADER_IRRELEVANT_AT}:{" "}
            {format(new Date(mention.marked_irrelevant_at), "yyyy-MM-dd kk:mm")}
          </Typography>
        )}
        {mention.marked_irrelevant_reason && (
          <Typography variant="body-2" margin="none" className={styles.info}>
            {L.MENTIONS_VIEW_HIDDEN_LIST_HEADER_IRRELEVANT_REASON}:{" "}
            {mention.marked_irrelevant_reason}
          </Typography>
        )}
        <Typography
          variant="body-2"
          margin="none"
          className={styles.info}
          data-testid="marked_irrelevant_by"
        >
          {L.MENTIONS_VIEW_HIDDEN_LIST_HEADER_IRRELEVANT_BY}:{" "}
          {mention.marked_irrelevant_by}
        </Typography>
      </AccessControl>
    </ListMention>
  );
};
export default MentionRow;
